import { useEffect } from 'react';
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import usePageMeta from '../../../hooks/usePageMeta';

const reviews = [
  {
    id: 1,
    content: "고1 겨울방학부터 2년째 다니고 있는데 관리가 체계적으로 잘돼서 믿고 보내고 있어요~ 아이도 만족하구요~^^",
    author: "핑*빛 하늘",
    date: "2026.02.20",
    source: "옥토피아",
    rating: 5
  },
  {
    id: 2,
    content: "제가 이사와서 가장 잘한 일~ 두 아이 미래인재학원 보낸거에요^^ 덕분에 큰 아이 인서울했고, 둘째아이 다니는 중이에요~ 늘 감사하게 생각하는 학원이에요!^^",
    author: "*로롱",
    date: "2026.02.20",
    source: "옥토피아",
    rating: 5
  },
  {
    id: 3,
    content: "두 아이와 부모 모두 만족하며 학원보내고 있습니다. 점점 아이의 실력은 좋아지고 있구요. 장학금 받으며 다니고 있습니다 :) 교육정보도 잘 받고 있구요 최고!",
    author: "*즈",
    date: "2026.02.20",
    source: "옥토피아",
    rating: 5
  },
  {
    id: 4,
    content: "수업 분위기가 체계적으로 잘 잡혀 있어 아이가 즐겁게 다닐 수 있었어요😊 매번 꼼꼼하게 피드백을 주셔서 학습 방향을 이해하는 데 많은 도움이 되었고, 자연스럽게 실력 향상으로 이어지는 모습에 만족도가 높았습니다. 아이도 자신감이 많이 생겨 앞으로의 변화가 더욱 기대됩니다✨",
    author: "행*",
    date: "2026.02.20",
    source: "옥토피아",
    rating: 5
  },
  {
    id: 5,
    content: "이사와서 젤 고민이었어요. 막내 중등입학으로 올해로 세 아이 모두 미래인재를 다니게 되었네요. 부모뿐아니라 학생도 만족하며 다니고 있어요",
    author: "전*맘",
    date: "2026.02.20",
    source: "옥토피아",
    rating: 5
  },
  {
    id: 6,
    content: "전 학원이랑 비교해보면 공부하는 분위기가 잡혀있다고 오히려 아이들이 그러더라구요. 믿고 보내는 학원이에요",
    author: "*이*이맘",
    date: "2026.02.20",
    source: "옥토피아",
    rating: 5
  },
  {
    id: 7,
    content: "상담선생님들 따로계시니 체계적으로 운영되고있어서 문의사항있을 때 빠르게 회신도 되고 친절하시구요. 수업도 레벨별로 진행하니 실력향상에도 도움되고있습니다. 월간고사로 스스로 동기부여하면서 열심히 할수있고요 두아이 다 만족하며 보냅니다",
    author: "*로새길",
    date: "2026.02.20",
    source: "옥토피아",
    rating: 5
  },
  {
    id: 8,
    content: "이사와서 학원 알아보는데 미래인재를 많이 추천하더라구요~그렇게 다니기 시작한게 1년을 꽉 채웠네요. 아이도 많은 도움이 된다하고 저도 피드백 바로 받을수 있어 매우 만족해요. 관리 잘되는 학원 원하시면 미래인재 추천합니다!!",
    author: "*집사",
    date: "2026.02.20",
    source: "옥토피아",
    rating: 5
  },
  {
    id: 9,
    content: "중1학년부터 지금 고2. 되는 시점까지 미래인재학원에 아이 둘다 다니고 있습니다 훌륭한 강사진에 좋은 환경 옥정에 이만한 학원이 없죠",
    author: "*호맘",
    date: "2026.02.20",
    source: "옥토피아",
    rating: 5
  },
  {
    id: 10,
    content: "초등학교때부터 중학생까지 옥정 이사와서 믿고 보내는 미래인재입니다👍🏻 주변에도 추천하고있어요 둘째도 보낼생각입니다^^",
    author: "*메리",
    date: "2026.02.20",
    source: "옥토피아",
    rating: 5
  },
  {
    id: 11,
    content: "아이 2명을 현재 미래인재학원에 보내고 있는 엄마입니다. 처음 대형학원이라 우리아이랑 맞을지 걱정이 좀 있었는데 1년 가까이 보내며 아이들도, 저도 모두 만족하며 보내고 있습니다. 시험기간에는 휴일을 포기하고 열정가득 아이들을 가르쳐주시는 선생님들께 진심으로 감사드립니다.^^",
    author: "*루아라맘",
    date: "2026.02.20",
    source: "옥토피아",
    rating: 5
  },
  {
    id: 12,
    content: "저희 아이도 3년째 만족하면서 보내고 있습니다. 개별수준별 학급편성,진도진행되서 좋구 실력이 향상되는게 확실히 느껴집니다.^^ 감사한 학원입니다.",
    author: "*호야맘",
    date: "2026.02.20",
    source: "옥토피아",
    rating: 5
  },
  {
    id: 13,
    content: "큰아이 미래 보낸지 1년 되었는데 이렇게 보충해 주는 곳 첨 봤습니다. 늦게까지 남아서 보충해 주시고 시간이 안맞으면 다시 시간을 맞춰서라도 끝까지 책임져 주시고 학부모 피드백까지 확실히 해 주시니 성적도 잘 나와서 믿고 맡깁니다.",
    author: "*주고고",
    date: "2026.02.20",
    source: "옥토피아",
    rating: 5
  },
  {
    id: 14,
    content: "선생님들이 열성적으로 수업해주십니다 숙제검사도 잘 해주시고 출결체크도 바로바로 해주십니다 아이도 저도 만족합니다",
    author: "*주만두",
    date: "2026.02.20",
    source: "베이비러브(양주시 대표 맘카페)",
    rating: 5
  },
  {
    id: 15,
    content: "중2 여름부터 다니기 시작했는데 어느덧 고1이네요 영어를 너무 힘들어해서 보냈는데 덕분에 중학교 내내 아이가 만족스러운 성적 어을 수 있었습니다 늘 감사하고 있어요",
    author: "*차니스트",
    date: "2026.02.20",
    source: "베이비러브(양주시 대표 맘카페)",
    rating: 5
  },
  {
    id: 16,
    content: "2년째 다니고 있어요~ 처음엔 숙제양이 많아서 좀 힘들어했지만 지금은 적응해서 잘 다니고 있습니다~ 관리 잘해주시고 아이도 만족하고 있어요~^^",
    author: "*트빛하늘",
    date: "2026.02.20",
    source: "베이비러브(양주시 대표 맘카페)",
    rating: 5
  },
  {
    id: 17,
    content: "두아이 보내고 있습니다 큰아이는 장학금 받으면서요:) 실력이 많이 좋아졌어요 옥정미래를 책임지는 학원~^^",
    author: "*크소세지",
    date: "2026.02.20",
    source: "베이비러브(양주시 대표 맘카페)",
    rating: 5
  },
  {
    id: 18,
    content: "초6부터 현 예비고2까지. 6년째 미래인재를 믿고 다니고 있습니다. 앞으로 2년. 열심히 공부해서 좋은 결과 있기를 바래봅니다! 항상 감사합니다",
    author: "*돌이여부",
    date: "2026.02.20",
    source: "베이비러브(양주시 대표 맘카페)",
    rating: 5
  },
  {
    id: 19,
    content: "수학만 다니다 올해부터는 영어도 함께 듣고 있어요. 아이가 수업에 대한 만족도가 높아요. 수학 조금 어려워했는데 지금은 그런게 없어져서 좋아요.",
    author: "*지*준*준맘",
    date: "2026.02.20",
    source: "동두천 알뜰맘",
    rating: 5
  },
  {
    id: 20,
    content: "현재 고등학교 2학년 남학생 학부모입니다. 중학교 때부터 영어와 수학을 꾸준히 다니며 방학 동안 윈터스쿨 수업도 함께 수강해 왔습니다. 처음에는 '잘 가르치는 학원'을 찾는 마음으로 보내게 되었지만, 선생님들의 체계적인 수업과 꼼꼼한 학생 관리, 그리고 세심한 피드백 덕분에 아이의 성적 향상에 큰 도움이 되어 지금까지 믿고 보내고 있습니다. 아이 입장에서는 숙제가 많아 힘들다고 말할 때도 있지만, 주어진 과제는 수업의 연장선이며 결석 시에도 함께 배우는 친구들과의 학습 흐름을 맞추기 위한 과정이라고 생각합니다. 시간이 지나면서 아이도 그 의미를 이해하고 잘 따라가고 있습니다. 무엇보다 학습 지도뿐만 아니라 때로는 멘토로서 아이의 고민을 들어주시고 방향을 제시해 주시는 모습에 학부모로서 깊이 감사드립니다. 앞으로도 지금처럼 학생 한 명 한 명을 진심으로 지도해 주시길 바랍니다. 항상 감사드립니다.",
    author: "*니쓰리맘",
    date: "2026.02.20",
    source: "동두천 알뜰맘",
    rating: 5
  },
  {
    id: 21,
    content: "큰애 올해 졸업해 대학가서 한시름 놨고 둘째,셋째도 잘하리라 믿습니다 초등학교때부터 지금까지 학원한번 바꾸지 않고 쌤들을 믿으며 보내고 있습니다",
    author: "*블리",
    date: "2026.02.20",
    source: "동두천 알뜰맘",
    rating: 5
  },
  {
    id: 22,
    content: "옥정고 1학년 학생 엄마 입니다.중학교 1학년때 아이가 직접 선택한 학원이었는데, 아이 선택을 존중했습니다.그때부터 미래인재~쭈욱 다녔는데, 이번에 좋은 성적으로 1등급~^^ 수학을 참 좋아하는 아이입니다. 첫 학원선택을 참 잘해준 우리 아이도 기특하지만 아이의 컨디션부터 아이의 속도에 맞춰 늘 세심하게 관심주시는 선생님들께 늘 감사한 마음입니다~",
    author: "두*맘",
    date: "2025.07.19",
    source: "옥토피아",
    rating: 5
  },
  {
    id: 23,
    content: "다른 곳 다니다 그만두고 아이한테 맞는 곳을 찾다가 다닌지 얼마 안됐습니다!\n\n숙제가 많고 빡세다는(?) 얘기를 듣고 걱정 반 기대반으로 상담받아 등록을 했는데 일단 아이가 아주 만족하며 다니고 있어요😍\n숙제가 생각외로 많지도 않고 선생님이 잘 가르쳐 준다고 하네요~!\n아이가 새로운 곳은 많이 부담스러워 하는데 계속 다녀보겠다고 해서 감동을🥹🥹\n\n카톡으로 아이가 어디까지 배웠지는,어느 부분을 마스터했는지 꼼꼼히 알려주세요\n미래인재 등록전에 예전에 이곳을 다녔던 조카가 옥정에서 체계가 제일 잘 잡힌 곳이라고 했거든요\n믿고 계속 보내려고 합니다!",
    author: "1211*",
    date: "2025.07.19",
    source: "옥토피아",
    rating: 5
  },
  {
    id: 24,
    content: "돌고돌아 다시 선택한 미래인재^^;;;\n고딩은 무조건 미래인재인거 같아요\n빠른 피드백 만족합니다^^",
    author: "*루레몬",
    date: "2025.07.19",
    source: "옥토피아",
    rating: 5
  }
];

export default function ReviewsPage() {
  usePageMeta({
    title: '미래인재학원 학부모 후기',
    description: '미래인재학원 학부모님들의 생생한 후기를 확인하세요. 실제 수강 경험과 성적 향상 사례를 통해 학원의 교육 품질을 확인할 수 있습니다.',
    path: '/news/reviews',
    keywords: '미래인재학원 후기, 학부모 후기, 수강 후기, 성적 향상, 입시학원 리뷰',
  });

  return (
    <div className="min-h-screen bg-white">
      <Navigation currentPage="reviews" />

      {/* Hero */}
      <section className="pt-20 relative min-h-[200px] md:min-h-[320px] flex items-center">
        <div className="absolute inset-0 bg-black">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(251,191,36,0.12)_0%,transparent_50%)]"></div>
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_80%,rgba(251,191,36,0.08)_0%,transparent_40%)]"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16 w-full">
          <div className="max-w-2xl">
            <span className="text-yellow-400 font-semibold text-xs md:text-sm tracking-wider uppercase">
              Reviews
            </span>
            <h1 className="text-2xl md:text-5xl font-bold text-white mt-2 md:mt-4 mb-2 md:mb-4">
              미래인재학원 학부모 후기
            </h1>
            <p className="text-sm md:text-lg text-gray-300 leading-relaxed">
              미래인재학원을 경험한 학부모님들의 생생한 후기입니다
            </p>
          </div>
        </div>
      </section>

      {/* Reviews Section */}
      <section className="py-12 md:py-20 px-3 md:px-4 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 bg-yellow-400/10 text-yellow-500 text-sm font-semibold rounded-full mb-4">
              REVIEWS
            </span>
            <h3 className="text-2xl md:text-3xl font-black text-gray-900 mb-3">
              학부모님들의 <span className="text-yellow-500">생생한 후기</span>
            </h3>
            <p className="text-gray-500 text-sm">
              미래인재학원을 경험한 학부모님들의 실제 후기입니다
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {reviews.map((review) => (
              <div 
                key={review.id}
                className="bg-gradient-to-br from-yellow-50 via-white to-amber-50 border border-yellow-200/60 rounded-2xl p-6 hover:border-yellow-400 transition-all duration-300 hover:shadow-lg hover:shadow-yellow-400/10 group"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-yellow-400 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-thumb-up-fill text-lg text-black"></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-sm font-bold text-gray-900">{review.author}</span>
                      <span className="text-xs text-gray-400">|</span>
                      <span className="text-xs text-gray-400">{review.date}</span>
                    </div>
                    <div className="flex items-center gap-1 mt-0.5">
                      <span className="text-xs text-yellow-500 font-medium">{review.source}</span>
                    </div>
                  </div>
                  <div className="flex gap-0.5 flex-shrink-0">
                    {[...Array(review.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                </div>
                <p className="text-gray-700 text-sm leading-relaxed">
                  {review.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
